import { makeStyles, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import useNetwork from 'src/hooks/useNetwork';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
}));
const NetworkDetector = () => {
  const classes = useStyles();
  const { isOnline, message, clearMessage } = useNetwork();

  return (
    !isOnline &&
    message && (
      <div className={classes.root}>
        <Alert
          ariant="filled"
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                clearMessage();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </div>
    )
  );
};

export default NetworkDetector;
